import * as React from 'react';
import { Button } from '@mui/material';
import Dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterBar, useFilterBarStyles } from '../ui';
import { MIN_DATE_SENTINEL, dateParam } from '../../lib/orderFilters';

interface OrdersCountFiltersProps {
    queryParams: any;
    loadOrders: (params: any) => void;
    loading: boolean;
    onClear: () => void;
}

/** Date range of the "Units by client" report. */
export default function OrdersCountFilters({ queryParams, loadOrders, loading, onClear }: OrdersCountFiltersProps) {
    const classes = useFilterBarStyles();

    const handleFilterChange = (name: 'minDate' | 'maxDate', value: string) => {
        const next = { ...queryParams, [name]: value };
        if (name === 'maxDate' && !next.minDate) next.minDate = MIN_DATE_SENTINEL;
        if (name === 'minDate' && !next.maxDate) next.maxDate = Dayjs(new Date()).format('YYYY-MM-DD');
        loadOrders(next);
    };
    const onDateChange = (name: 'minDate' | 'maxDate') => (value: Dayjs.Dayjs | null) => {
        const iso = dateParam(value);
        if (iso) handleFilterChange(name, iso);
    };

    return (
        <FilterBar label="Report filters">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    className={classes.date}
                    label="From"
                    format="YYYY-MM-DD"
                    value={queryParams?.minDate && queryParams.minDate !== MIN_DATE_SENTINEL ? Dayjs(queryParams.minDate) : null}
                    maxDate={queryParams?.maxDate ? Dayjs(queryParams.maxDate) : Dayjs(new Date())}
                    disabled={loading}
                    onChange={onDateChange('minDate')}
                    slotProps={{ textField: { size: 'small' } }}
                />
                <DatePicker
                    className={classes.date}
                    label="To"
                    format="YYYY-MM-DD"
                    value={queryParams?.maxDate ? Dayjs(queryParams.maxDate) : Dayjs(new Date())}
                    maxDate={Dayjs(new Date())}
                    disabled={loading}
                    onChange={onDateChange('maxDate')}
                    slotProps={{ textField: { size: 'small' } }}
                />
            </LocalizationProvider>
            <Button className={classes.clear} variant="text" size="small" onClick={onClear} disabled={loading}>
                Reset to today
            </Button>
        </FilterBar>
    );
}
